import PrivateRoute from 'utils/privateRoute';
import ProgramDetails from 'components/DataPipeline/program-details';
import ProjectDetails from 'components/DataPipeline/project-details';
import AddSchedules from 'components/DataPipeline/add-schedules';
import CustomDashboard from 'components/DataPipeline/customDashboard';
import MarketDashboard from 'components/IBPDataPipeline/marketDashborad';
import programOpsDashboard from 'components/DataPipeline/programOpsDashboard';
import ProgramsDashboard from 'components/DataPipeline/programs-dashboard';
import NewDashboard from 'components/DataPipeline/newDashboard';
import ExecutiveOpsDashboard from 'components/DataPipeline/ExecutiveOps';
import DataopsExeLanding from 'components/DataPipeline/ExeOpsLandingPage';
import ProgramTabDashboard from 'components/DataPipeline/program-tab';
import ExecutiveTemplate from 'components/DataPipeline/executive-template';
import NewDashboardIBP from 'components/IBPDataPipeline/NewDashboard';
import IBPDashboard from 'components/IBPDataPipeline/IBPDashboard';
import ProgramTabDashboardIbp from 'components/IBPDataPipeline/program-tab-ibp';
import GdoTabs from 'components/IBPDataPipeline/GdoTabs';
import ProgramDetailsIBP from 'components/IBPDataPipeline/program-details';
import ProjectDetailsIBP from 'components/IBPDataPipeline/project-details';
import GBDOLineagePage from 'components/IBPDataPipeline/GBDOLineagePage';
import GdoDetails from 'components/IBPDataPipeline/gdo-details';
import StageDetails from 'components/IBPDataPipeline/stage-details';
import DataReconDashboard from 'components/DataPipeline/DataReconciliation/index';


const DataPipelineRoutes = [
  {
    key: 'dpipe_prgrm',
    route: '/data-pipeline/programs',
    component: (
      <PrivateRoute
        Component={ProgramsDashboard}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_new',
    route: '/data-pipeline/dataOps',
    component: (
      <PrivateRoute
        Component={NewDashboard}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_new_ibp',
    route: '/data-pipeline/programOps/IBP/markets/ibp-dashboard',
    component: (
      <PrivateRoute
        Component={NewDashboardIBP}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_ibp_dashboard',
    route: '/data-pipeline/programOps/IBP/markets/ibpDashboard',
    component: (
      <PrivateRoute
        Component={IBPDashboard}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_prgrm',
    route: '/data-pipeline/programs-tab',
    component: (
      <PrivateRoute
        Component={ProgramTabDashboard}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_prgrm',
    route: '/data-pipeline/ibp-dashboard/programs-tab',
    component: (
      <PrivateRoute
        Component={ProgramTabDashboardIbp}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_gdo_lineage',
    route: '/data-pipeline/ibpDashboard/lineage/:market',
    component: (
      <PrivateRoute
        Component={GBDOLineagePage}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_gdo_tabs',
    route: '/data-pipeline/ibpDashboard/gdoTabs',
    component: (
      <PrivateRoute
        Component={GdoTabs}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_gdo_details_alt',
    route: '/data-pipeline/ibpDashboard/gdo-details/:programId/:gdoName',
    component: (
      <PrivateRoute
        Component={GdoDetails}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_stage_details_alt',
    route: '/data-pipeline/ibpDashboard/stage-details/:gdoId/:stageId/:gdoName/:stageName',
    component: (
      <PrivateRoute
        Component={StageDetails}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_prgrm',
    route: '/data-pipeline/executiveTemplate',
    component: (
      <PrivateRoute
        Component={ExecutiveTemplate}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_exeops',
    route: '/data-pipeline/executiveOps/:dashboardType',
    component: (
      <PrivateRoute
        Component={ExecutiveOpsDashboard}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_exeops',
    route: '/data-pipeline/executiveOps/pepsellPepIrisRecon',
    component: (
      <PrivateRoute
        Component={DataReconDashboard}
        restrictedRoles={['Platform Operations Admin/SRE', 'D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_exeops_landing',
    route: '/data-pipeline/home/executiveOps',
    component: (
      <PrivateRoute
        Component={DataopsExeLanding}
        restrictedRoles={['D&AI Executive User', 'Program Executive', 'PwC_View', 'PwC_Edit']}
      />
    ),
  },
  {
    key: 'dpipe_prgrm_id_name',
    route: '/data-pipeline/programs/:id/:name',
    component: (
      <PrivateRoute
        Component={ProgramDetails}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_prgrm_id_name_ibp',
    route: '/data-pipeline/ibp-dashboard/programs/:id/:name',
    component: (
      <PrivateRoute
        Component={ProgramDetailsIBP}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_prgrm_prj_id_prgm_proj',
    route: '/data-pipeline/projects/:programId/:projectId/:program/:project',
    component: (
      <PrivateRoute
        Component={ProjectDetails}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_prgrm_prj_id_prgm_proj_1',
    route: '/data-pipeline/projects/:programId/:projectId/:program/:project/:projDate',
    component: (
      <PrivateRoute
        Component={ProjectDetails}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
    {
    key: 'dpipe_prgrm_prj_id_prgm_proj_ibp',
    route: '/data-pipeline/ibp-dashboard/projects/:programId/:projectId/:program/:project',
    component: (
      <PrivateRoute
        Component={ProjectDetailsIBP}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
   {
    key: 'dpipe_prgrm_id_name_ibp',
    route: '/data-pipeline/ibp-dashboard/projects/:programId/:projectId/:program/:project/:projDate',
    component: (
      <PrivateRoute
        Component={ProjectDetailsIBP}
        restrictedRoles={['D&AI Executive User', 'Program Executive']}
      />
    ),
  },
  {
    key: 'dpipe_srch_prgmid_prjid_name',
    route: '/data-pipeline/search-jobs/:prgmid/:prjid/:prgname/:prjname',
    component: (
      <PrivateRoute
        Component={AddSchedules}
        restrictedRoles={[
          'Platform Operations Admin/SRE',
          'D&AI Executive User',
          'Program Executive',
        ]}
      />
    ),
  },
  {
    key: 'dpipe_cust_dash_tiles',
    route: '/data-pipeline/programOpsDashboard',
    component: (
      <PrivateRoute
        Component={programOpsDashboard}
        restrictedRoles={[
          'Platform Operations Admin/SRE',
          'D&AI Executive User',
          'Program Executive',
          'PwC_View',
          'PwC_Edit'
        ]}
      />
    ),
  },
  {
    key: 'dpipe_cust_dash_tiles',
    route: '/data-pipeline/programOps/:programName/markets',
    component: (
      <PrivateRoute
        Component={MarketDashboard}
        restrictedRoles={[
          'Platform Operations Admin/SRE',
          'D&AI Executive User',
          'Program Executive',
        ]}
      />
    ),
  },
  {
    key: 'dpipe_cust_dash',
    route: '/data-pipeline/programOps/:programName/:marketName/list',
    component: (
      <PrivateRoute
        Component={CustomDashboard}
        restrictedRoles={[
          'Platform Operations Admin/SRE',
          'D&AI Executive User',
          'Program Executive',
        ]}
      />
    ),
  },
  {
    key: 'dpipe_cust_dash',
    route: '/data-pipeline/programOps/:programName/list',
    component: (
      <PrivateRoute
        Component={CustomDashboard}
        restrictedRoles={[
          'Platform Operations Admin/SRE',
          'D&AI Executive User',
          'Program Executive',
        ]}
      />
    ),
  },
];

export default DataPipelineRoutes;
